import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';

import { AspectRatioString } from '@fcom/common';
import { CmsArticle, CmsImageData, CmsMedia, CmsQueryListItem, CmsTeaserCard } from '@fcom/core-api';

@Component({
  selector: 'fin-teaser-card',
  templateUrl: './teaser-card.component.html',
  styleUrls: ['./teaser-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TeaserCardComponent {
  @Input()
  aspectRatio: AspectRatioString;
  @Input()
  content: CmsQueryListItem | CmsArticle | CmsTeaserCard;

  @Output()
  linkClicked: EventEmitter<void> = new EventEmitter(); // mainly for click tracking if normal link tracking is not enough

  emitClick(): void {
    this.linkClicked.emit();
  }

  getPics(media: CmsMedia[]): CmsImageData[] {
    return media.filter((m) => 'responsiveImageLinksData' in m) as CmsImageData[];
  }
}
